import React, { useState } from 'react';

import { Alert, Box, Button, Col, Paper, Row, Typography } from 'components/AORedesign';
import { useClaims } from 'hooks/useClaims';
import { ClaimsInquiryDetails } from '../ClaimsInquiryDetails';
import ClaimsDataGrid from './ClaimsDataGrid';
import OneStopClaimReporting from './OneStopClaimReporting';

const ClaimsStatus = () => {
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [currentRange, setCurrentRange] = useState(null);
  const [buttonLoading, setButtonLoading] = useState({ 30: false, 60: false, 90: false, 0: false });

  const { results, loadingSearchResults, error, handleSearchOnClick, handleClickPaginationChange } = useClaims();

  const handleFetchClaims = async (e) => {
    const searchByAmount = e.currentTarget.value;
    setButtonLoading((prevState) => ({ ...prevState, [searchByAmount]: true }));
    setCurrentRange(searchByAmount);
    await handleSearchOnClick('openClaims', 'openClaims', searchByAmount);
    setButtonLoading((prevState) => ({ ...prevState, [searchByAmount]: false }));
  };

  const handleOnPageChange = (page) => handleClickPaginationChange(page, 'openClaims', 'openClaims', currentRange);

  const handleCloseClaimsInquiryDetails = () => setSelectedClaim(null);

  return (
    <>
      <Typography variant="h5" style={{ marginBottom: 16 }}>
        Open Claims Status
      </Typography>

      <Row justifyContent={'space-between'} spacing={2}>
        <Col>
          <Paper>
            <Box>
              <Typography id="ClaimsTypographySubtitle" variant="subtitle1" style={{ marginBottom: '16px' }}>
                Search Open Claims
              </Typography>

              <Row spacing={1}>
                <Col xs={6}>
                  <Button value="30" variant="outlined" color="secondary" style={{ width: '175px' }} loading={buttonLoading['30']} onClick={handleFetchClaims}>
                    Last 30 Days
                  </Button>
                </Col>
                <Col xs={6}>
                  <Button value="60" variant="outlined" color="secondary" style={{ width: '175px' }} loading={buttonLoading['60']} onClick={handleFetchClaims}>
                    Last 60 Days
                  </Button>
                </Col>
              </Row>
              <Row spacing={1}>
                <Col xs={6}>
                  <Button value="90" variant="outlined" color="secondary" style={{ width: '175px' }} loading={buttonLoading['90']} onClick={handleFetchClaims}>
                    Last 90 Days
                  </Button>
                </Col>
                <Col xs={6}>
                  <Button value="0" variant="outlined" color="secondary" style={{ width: '175px' }} loading={buttonLoading['0']} onClick={handleFetchClaims}>
                    Open Claims
                  </Button>
                </Col>
              </Row>
            </Box>
          </Paper>
        </Col>

        <Col xs={4}>
          <OneStopClaimReporting />
        </Col>
      </Row>

      {error && <Alert severity="error" message={error}></Alert>}

      <ClaimsDataGrid
        results={results}
        setSelectedClaim={setSelectedClaim}
        loadingSearchResults={loadingSearchResults}
        handleOnPageChange={handleOnPageChange}
        searchByType="openClaims"
      />

      {selectedClaim && <ClaimsInquiryDetails selectedClaim={selectedClaim} handleCloseClaimsInquiryDetails={handleCloseClaimsInquiryDetails} />}
    </>
  );
};

export default ClaimsStatus;
